import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'pace-confirmation-signature',
    templateUrl: './confirmation-signature.component.html',
    styleUrls: ['./confirmation-signature.component.scss'],
    standalone: false,
})
export class ConfirmationSignatureComponent implements OnInit {
    @Input()
    public customerSignature: string;
    @Input()
    public cseSignature: string;

    public modalResult = new Subject<boolean>();
    public customerSignatureUrl: SafeUrl;
    public cseSignatureUrl: SafeUrl;
    public constructor(
        public readonly modalInstance: BsModalRef,
        private sanitizer: DomSanitizer,
    ) {}

    public ngOnInit(): void {
        this.customerSignatureUrl = this.sanitizer.bypassSecurityTrustUrl(
            'data:image/jpg;base64,' + this.customerSignature,
        );
        if (typeof this.cseSignature !== 'undefined') {
            this.cseSignatureUrl = this.sanitizer.bypassSecurityTrustUrl('data:image/jpg;base64,' + this.cseSignature);
        }
    }

    public onCancel(): void {
        this.modalResult.next(false);
        this.modalInstance.hide();
    }

    public onSubmit(): void {
        this.modalResult.next(true);
        this.modalInstance.hide();
    }
}
